var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'active:outline-none focus:outline-none transition-colors duration-150': true,
    'text-[#F95E16] font-medium': _vm.active,
    'text-[#626262] hover:text-[#222222]': !_vm.active,
  },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }